/* eslint import/prefer-default-export: 0 */

import numeral from 'numeral';
import { clamp } from 'lodash';

import t from './translate';

export function displayPrice(price = 0, currencySymbol = '') {
  if (price === 0) {
    return t('FREE');
  }

  const formatStr = Number.isInteger(price) ? '0' : '0.00';

  return `${currencySymbol}${numeral(price).format(formatStr)}`;
}

export function getCostSplit(cost, balance, bonusBalance, bonusFreeCost = 0) {
  const bonus = clamp(bonusBalance, 0, cost - bonusFreeCost);
  const primary = Math.min(balance, cost - bonus);
  return {
    bonus,
    primary
  };
}
